import { Component } from '@angular/core';
import {LoadingController, NavController, NavParams} from 'ionic-angular';
import {WorkReportProvider} from "../../providers/work-report/work-report";
import {WorkReportPage} from "../work-report/work-report";
import {ValidationProvider} from "../../providers/validation/validation";
import {ToastProvider} from "../../providers/toast/toast";

/**
 * Generated class for the CreateWorkReportPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-create-work-report',
  templateUrl: 'create-work-report.html',
})
export class CreateWorkReportPage {
  salesOrder: any;
  workReports: any = [];
  workReportName: string;
  date: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private loadingCtrl: LoadingController,
    private workReportProvider: WorkReportProvider,
    private validation: ValidationProvider,
    private toast: ToastProvider
  ) {
    this.salesOrder = this.navParams.get('salesOrder');
    this.workReports = this.navParams.get('workReports');

    let now = new Date();
    this.date = `${now.getFullYear()}-${now.getMonth()+1}-${now.getDate()}`;
  }

  ionViewDidLoad() {
  }


  validate() {
    this.validation.init();

    // if (this.doesDuplicatesExist(this.workReports, this.date)) {
    //   this.validation.addError('Es gibt bereits einen Arbeitsbericht an diesem Tag, Arbeitsbericht konnte nicht erstellt werden.');
    // }
  }

  private doesDuplicatesExist(workReports: any, date: any) {
    for (let existingWorkReport of workReports) {
      if (date == existingWorkReport.date_work) {
        return true;
      }
    }
    return false;
  }

  async save() {
    let loading = this.loadingCtrl.create({ content: "Arbeitsbericht wird erstellt, bitte warten ..." });
    loading.present();

    // @ts-ignore
    this.workReportName = await this.workReportProvider.create(this.salesOrder, this.date);

    loading.dismiss();
  }

  async safeSave() {
    this.validate();

    if (this.validation.isValid) {
      await this.save();

      if (!this.workReportName) {
        this.toast.error('Arbeitsbericht konnte nicht gespeichert werden, es ist ein Fehler aufgetreten.');

        return null;
      }
    } else {
      this.validation.showMessages();
    }
  }

  async saveAndGoBack() {
    await this.safeSave();

    if (this.workReportName) {
      this.navCtrl.pop();

      this.navCtrl.push(WorkReportPage, {
        salesOrder: this.salesOrder,
        workReportName: this.workReportName,
        workReports: this.workReports,
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/create-work-report/create-work-report.ts